import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SendDataService {
  private data: any;
  private readonly STORAGE_KEY = 'te-send-data-cache';

  setData(data: any) {
    this.data = data;
    this.saveToStorage(data);
  }

  getData(): any {
    if (this.data) {
      return this.data;
    }
    this.data = this.readFromStorage();
    return this.data;
  }

  clearData() {
    this.data = null;
    this.clearStorage();
  }

  private saveToStorage(value: any) {
    if (!this.isSessionStorageAvailable()) {
      return;
    }
    try {
      const serialized = JSON.stringify(value ?? null);
      sessionStorage.setItem(this.STORAGE_KEY, serialized);
    } catch (error) {
      console.warn('SendDataService: failed to persist data', error);
    }
  }

  private readFromStorage(): any {
    if (!this.isSessionStorageAvailable()) {
      return null;
    }
    const raw = sessionStorage.getItem(this.STORAGE_KEY);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch (error) {
      sessionStorage.removeItem(this.STORAGE_KEY);
      return null;
    }
  }

  private clearStorage() {
    if (!this.isSessionStorageAvailable()) {
      return;
    }
    sessionStorage.removeItem(this.STORAGE_KEY);
  }

  private isSessionStorageAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
  }
}
